"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const breakpoints = {
    tabletSmall: 576,
    tabletMedium: 768,
    tabletLarge: 992,
    desktop: 1200,
};
exports.default = breakpoints;
//# sourceMappingURL=resolution-variables.js.map